import { Transition } from "@headlessui/react";
import React, { ReactNode } from "react";

interface Props {
  children: ReactNode;
  isOpen: boolean;
  handleClose: () => void;
}

export default function EditSideMenuSP({
  children,
  isOpen,
  handleClose,
}: Props) {
  return (
    <Transition appear show={isOpen}>
      <div className="fixed z-10">
        <Transition.Child
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className="fixed inset-0 bg-black/50 md:hidden"
            onClick={handleClose}
          />
        </Transition.Child>
        <Transition.Child
          enter="ease-out duration-300"
          enterFrom="opacity-0 -translate-x-6"
          enterTo="opacity-100 translate-x-0"
          leave="ease-in duration-100"
          leaveFrom="opacity-100 translate-x-0"
          leaveTo="opacity-0 -translate-x-6"
        >
          <aside
            id="sidebar"
            className="block overflow-y-auto fixed top-0 left-0 z-10 w-[256px] h-screen bg-gray-100 border-r border-theme-light"
          >
            {children}
          </aside>
        </Transition.Child>
      </div>
    </Transition>
  );
}
